<nz-modal
    nzWidth="700px"
    [(nzVisible)]="isVisible"
    (nzOnCancel)="close()"
    [nzOkText]="null"
    [nzCancelText]="null"
>
    <ng-container *nzModalContent>
        <div *ngIf="detail" class="content-container">
            <div class="header-container">
                <div *ngIf="detail.status" class="status-label">
                    {{ detail.status }}
                </div>

                <div class="button-group">
                    <button nz-button class="text-btn-primary" (click)="handleShare()">Share</button>

                    <button nz-button class="text-btn-primary" (click)="handleApprove()">Approve</button>

                    <button nz-button class="text-btn-danger" (click)="handleReject()">Reject</button>
                </div>
            </div>

            <div class="info-container">
                <div class="item">
                    <div class="item-label">Engineer</div>
                    <div class="item-value">
                        {{ detail.testerName }}
                    </div>
                </div>

                <div class="item">
                    <div class="item-label">Project Name</div>
                    <div class="item-value">
                        {{ detail.projectName }}
                    </div>
                </div>

                <div class="item">
                    <div class="item-label">Type</div>
                    <div class="item-value">
                        {{ detail.projectType }}
                    </div>
                </div>

                <div class="item">
                    <div class="item-label">Prime</div>
                    <div class="item-value">{{ detail.primeUserName }}</div>
                </div>


                <div class="item">
                    <div class="item-label">Start Date</div>
                    <div class="item-value">
                        {{ detail.startDate | date: 'yyyy-MM-dd' }}
                    </div>
                </div>

                <div class="item">
                    <div class="item-label">End Date</div>
                    <div class="item-value">
                        {{ detail.endDate | date: 'yyyy-MM-dd' }}
                    </div>
                </div>
            </div>

            <div class="description">
                <div class="item-label">Description</div>
                <div class="item-value">{{ detail.description }}</div>
            </div>

            <div class="comments">
                <div class="item-label">Comments</div>
                <div class="item-value">{{ detail.comments }}</div>
            </div>

            <nz-collapse
                nzExpandIconPosition="right"
                class="calendar-container"
                nzGhost
                [nzBordered]="false"
            >
                <nz-collapse-panel
                    [nzActive]="true"
                    nzHeader="Calendar View"
                    class="panel-item"
                >
                    <app-timeline
                        #calendar
                        [resources]="resources"
                        [events]="events"
                        class="calendar"
                    ></app-timeline>
                </nz-collapse-panel>
            </nz-collapse>
        </div>
    </ng-container>
</nz-modal>
